// extracted by mini-css-extract-plugin
export default {"addBtn":"Transactions_addBtn__XDmLe shared_btnBase__l2+Rr"};